
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.5 12a8.463 8.463 0 01-1.832 5.272c.01.06.02.118.028.178a4.72 4.72 0 01-.164 2.123A9.977 9.977 0 0022 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.332 4.173 9.69 9.431 9.984.766.054 1.732-.01 2.715-.208 1.014-.203 1.571-.425 2.345-.988.982-.715 1.399-1.94 1.216-3.193-.223-1.52-1.041-2.594-2.77-4.266a3.677 3.677 0 00-.65-4.317l-1.509-1.508-.89.89L9.964 6.47a.75.75 0 00-1.061 1.06l1.924 1.925-1.263 1.263L7.64 8.794a.75.75 0 00-1.061 1.06l1.924 1.925-.922.922 1.508 1.508a3.676 3.676 0 004.886.278c1.628 1.59 2.103 2.333 2.248 3.325.117.805-.162 1.433-.615 1.763-.569.415-.917.562-1.757.73a9.453 9.453 0 01-2.107.194v-.003A8.5 8.5 0 1120.5 12zm-10.744.755l.394.394a2.175 2.175 0 103.076-3.076l-.394-.394-3.076 3.076z","fill":"currentColor"}})])
          )
        }
      }
    